import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page-container">
      <h1 className="legal-title">מדיניות פרטיות – אורבניקס (Urbanix)</h1>
      <p className="legal-subtitle">עודכן לאחרונה: {new Date().toLocaleDateString('he-IL')}</p>

      <div className="legal-section">
        <p className="legal-text">
          אנו באורבניקס מכבדים את פרטיותך ומחויבים להגן על המידע האישי שאתה משתף עמנו.
        </p>
        <p className="legal-text">
          מדיניות זו מסבירה כיצד אנו אוספים, משתמשים ושומרים על המידע שלך בעת השימוש באתר ובשירותים שלנו.
        </p>
      </div>

      <div className="legal-section">
        <h3>איסוף מידע</h3>
        <p className="legal-text">
          אנו עשויים לאסוף מידע שאתה מספק לנו באופן ישיר (כגון שם, אימייל, פרטי נכס) וכן מידע שנאסף אוטומטית בעת הגלישה באתר (כגון כתובת IP, סוג דפדפן).
        </p>
      </div>

      <div className="legal-section">
        <h3>שימוש במידע</h3>
        <p className="legal-text">
          המידע משמש אותנו לצורך מתן השירות, שיפור חווית המשתמש, יצירת קשר עמך (בכפוף להסכמתך), וניתוח סטטיסטי אנונימי.
        </p>
      </div>

      <div className="legal-section">
        <h3>אבטחת מידע</h3>
        <p className="legal-text">
          אנו נוקטים באמצעי אבטחה מקובלים כדי להגן על המידע שלך מפני גישה בלתי מורשית. עם זאת, אין אבטחה הרמטית ברשת האינטרנט.
        </p>
      </div>

      <div className="legal-section">
        <h3>יצירת קשר</h3>
        <p className="legal-text">
          לשאלות בנושא פרטיות, ניתן לפנות אלינו בכתובת: <strong>contact@urbanix.ai</strong>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

